module.exports = __webpack_public_path__ + "static/media/info-information.13a6adae.png";